// extracted by mini-css-extract-plugin
module.exports = {"main":"privacyPolicy_main__2ptGZ","title":"privacyPolicy_title__WY7l6","privacy":"privacyPolicy_privacy__3CVOj","policycard":"privacyPolicy_policycard__3ewfI"};